import { render, staticRenderFns } from "./ApprovalMessageBell.vue?vue&type=template&id=4742db8f&scoped=true"
import script from "./ApprovalMessageBell.vue?vue&type=script&lang=js"
export * from "./ApprovalMessageBell.vue?vue&type=script&lang=js"
import style0 from "./ApprovalMessageBell.vue?vue&type=style&index=0&id=4742db8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742db8f",
  null
  
)

export default component.exports